import VanillaModal from 'vanilla-modal';
import Log from './log';

export default class contentModal {
  constructor() {
    // Elements
    this.contentModal = $('.js-content_modal');
    this.imageModal = $('.js-image_modal');
    this.autoOpenModal = contentModal.getUrlParameter('modal');

    // Variables
    this.defaultOptions = {
      modal: '.modal',
      modalInner: '.modal-inner',
      modalContent: '.modal-content',
      open: '[data-modal-open]',
      close: '[data-modal-close]',
      page: 'body',
      loadClass: 'has-modal',
      class: 'has-modal--visible',
      clickOutside: true,
      closeKeys: [27],
      transitions: true,
    };

    if (this.contentModal.length) {
      const modal = new VanillaModal(this.defaultOptions);
      this.contentModal.on('click', (event) => { contentModal.openContentModal(modal, event); });
    }

    if (this.imageModal.length) {
      const modal = new VanillaModal(this.defaultOptions);
      this.imageModal.on('click', (event) => { contentModal.openImageModal(modal, event); });
    }

    if (this.autoOpenModal && $(`#${this.autoOpenModal}`).length) {
      const modal = new VanillaModal(this.defaultOptions);
      const id = `#${this.autoOpenModal}`;
      modal.open(id);
      Log.track('Modal', 'opened', id);
    }
  }

  static openContentModal(modal, event) {
    event.preventDefault();
    const target = $(event.currentTarget).attr('href');
    modal.open(target);
    Log.track('Modal', 'opened', target);
  }

  static openImageModal(modal, event) {
    event.preventDefault();
    const element = $(event.currentTarget);
    const imageSrc = element.data('image-src');
    const imageAlt = element.data('image-alt');
    const target = element.attr('href');
    $(target).find('img').attr('src', imageSrc).attr('alt', imageAlt);
    modal.open(target);
    Log.track('Modal', 'opened', `Image: ${imageAlt}`);
  }

  static getUrlParameter(name) {
    const parsedName = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp(`[\\?&]${parsedName}=([^&#]*)`);
    const results = regex.exec(window.location.search);
    return results === null ? false : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }
}
